import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Text, Container } from '@coinflare/ui/core';

import { FOOTER_HEIGHT, HEADER_HEIGHT } from 'src/common/constants';
import { useAppSelector } from 'src/hooks';

export const NotFound = () => {
    const { t } = useTranslation();

    const { theme } = useAppSelector((state) => state.global);

    return (
        <Container height={'100%'}>
            <Flex
                minHeight={`calc(100vh - ${HEADER_HEIGHT} ${
                    !theme.isMobile ? `- ${FOOTER_HEIGHT}` : ''
                })`}
                width={'100%'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Text variant={'h3'} text={t('not_found')} />
            </Flex>
        </Container>
    );
};
